import React, { useCallback } from 'react';
import { useFormState } from 'react-final-form';
import { useParams } from 'react-router-dom';

import { alertError, alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useCreateWaypointTemplatePreviewMutation } from '@dashboard/generated/wp/platform';
import parseJsonObject from '@dashboard/utilities/parseJsonObject';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useCurrentPreviewVariables } from '../hooks';

import SuccessMessage from './SuccessMessage';

export default function PreviewButton() {
  const id = useParams<{ id: string }>().id!;
  const { values } = useFormState();
  const [previewTemplate, { loading }] = useCreateWaypointTemplatePreviewMutation();
  const { input } = useCurrentPreviewVariables();
  const currentPreviewVariables = input.value;

  const onClick = useCallback(async () => {
    try {
      const { data } = await previewTemplate({
        variables: {
          id,
          variables: parseJsonObject(currentPreviewVariables),
          configuration: values.configuration,
        },
      });
      const previewId = data?.createWaypointTemplatePreview.id;
      if (previewId) {
        alertSuccess(<SuccessMessage emailMessageId={previewId} />);
      }
    } catch (error) {
      alertError('There were errors creating the PREVIEW draft');
    }
  }, [values, currentPreviewVariables, id, previewTemplate]);

  return (
    <Box sx={{ mt: 4, bgcolor: 'cadet.100', p: 2, border: '1px solid', borderColor: 'cadet.300' }}>
      <Typography variant="overline" gutterBottom color="text.secondary">
        Test this template
      </Typography>

      <Stack direction="row" justify-content="space-between" spacing={2} alignItems="center" mb={1}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography color="text.secondary" variant="body2">
            Email a test to yourself using the test data in the 'Data' tab.
          </Typography>
        </Box>
        <Box sx={{ flexShrink: 0 }}>
          <Button disabled={loading} variant="contained" color="secondary" onClick={onClick} size="small">
            Send test
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
